
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import backendUrl from '../../apiConfig'
import axios from 'axios'
export default function AddProfileDetails() {
    const [title, setTitle] = useState('')
    const [bio, setBio] = useState('')

    const navigate = useNavigate()


    const handleBioChange = (e) => {
        const text = e.target.value
        if (text.length <= 80) {
            setBio(text)
        }
    }



    const changeUserDetails = async () => {
        const token = localStorage.getItem("jwtToken")
        try {
            await axios.put(
                `${backendUrl}/user/bio`,
                { newBio: bio },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log("doneeeeeeeeee");
        } catch (err) {
            console.error("Error editing profile:", err);
        }
    };


    const changeUserFullname = async () => {
        const token = localStorage.getItem("jwtToken")

        try {
            await axios.put(
                `${backendUrl}/user/fullname`,
                { newFullname: title },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log("doneeeeeeeeee");
        } catch (err) {
            console.error("Error editing profile:", err);
        }
    };





    const handleSubmit = () => {

        changeUserDetails()
        changeUserFullname()
        navigate("/success")
    }

    return (
        <div className="min-h-screen bg-white text-black px-4 py-6">

            {/* progress bar */}
            <div className="fixed top-0 left-0 right-0 h-1 bg-gray-100">
                <div className="h-full bg-purple-500 w-3/4" />
            </div>

            {/* navigation */}
            <div className="fixed top-4 left-4 right-4 flex justify-between">
                <button
                    onClick={() => navigate(-1)}
                    className="text-sm text-gray-500 hover:text-gray-900"
                >
                    Back
                </button>
                <button
                    onClick={() => { navigate('/success') }}
                    className="text-sm text-gray-500 hover:text-gray-900"
                >
                    Skip
                </button>
            </div>

            {/* Main Content */}
            <div className="max-w-[600px] mx-auto">
                <h1 className="text-[42px] font-black text-center mb-12">
                    Add profile details
                </h1>


                {/* Title and Bio */}
                <div className="mb-8">
                    <h2 className="text-xl font-semibold mb-6 text-center">
                        Add Name and bio
                    </h2>
                    <div className="space-y-4">
                        <input
                            type="text"
                            placeholder="Profile title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            className="w-full p-4 bg-gray-50 rounded-lg border border-gray-100 focus:outline-none focus:ring-2 focus:ring-[#8B3DFF] transition-shadow"
                        />
                        <div className="relative">
                            <textarea
                                placeholder="Bio"
                                value={bio}
                                onChange={handleBioChange}
                                className="w-full p-4 bg-gray-50 rounded-lg border border-gray-100 focus:outline-none focus:ring-2 focus:ring-[#8B3DFF] transition-shadow resize-none h-32"
                            />
                            <span className="absolute bottom-4 right-4 text-sm text-gray-400">
                                {bio.length}/80
                            </span>
                        </div>

                    </div>
                </div>

                {/* Continue Button */}
                <button className="w-full bg-[#8B3DFF] hover:bg-[#7935E5] text-white font-medium py-4 px-6 rounded-full transition-colors" onClick={handleSubmit}>
                    Continue
                </button>
            </div>
        </div>
    )
}